define('modules/editor/models/property_groups/page_confirmation',['require','exports','module','./base'],function(require,exports,module){
  "use strict";
  var BasePg = require("./base");
  module.exports = BasePg.extend({
    name: "page:confirmation",
    properties: ["confirmationUrl", "sendParams"],
    defaultValues: {
      "confirmationUrl": "",
      "sendParams": false
    },
    validators: {
      "confirmationUrl": function(attrs){
        var isValid = this.isValidUrl(attrs.confirmationUrl);
        return isValid;
      }
    }
  });
});
